import React, { FC } from 'react';

import IconButton from '@material-ui/core/IconButton';
import CloseRoundedIcon from '@material-ui/icons/ChevronLeftRounded';
import ErrorIcon from '@material-ui/icons/Error';

interface IRoundScoreSummaryHeaderProps {
  onClose?: any;
  showWarning?: boolean;
}

const RoundScoreSummaryHeader: FC<IRoundScoreSummaryHeaderProps> = props => {
  const { onClose, showWarning } = props;

  return (
    <h3 className="round-score-heading">
      <IconButton aria-label="close" className="close" onClick={onClose} color="primary">
        <CloseRoundedIcon />
      </IconButton>

      <span className="main-heading">CONFIRM SCORES</span>

      {showWarning && <ErrorIcon color="secondary" className="warning" />}
    </h3>
  );
};

export default RoundScoreSummaryHeader;
